<template>
  <div class="careteam-list">
    <app-layout class="careteam-list-template">
      <Row type="flex" justify="center">
        <i-col :span="24" v-for="(item, k) in 10" :key="k">
          <Card
          shadow
          :style="{height: '60px', borderRadius: '0', cursor: 'pointer', borderTop: '1px solid #F2F2F2'}"
          :padding="0">
          <Row>
            <i-col :span="24">
              <div class="careteam-info">
                Care Team
              </div>
            </i-col>
          </Row>
        </Card>
        </i-col>
      </Row>
    </app-layout>
  </div>
</template>

<script>
export default {
  name: 'CareTeamList',
  computed: {
    user() {
      return this.$store.state.user.info
    },
    careteams() {
      return this.$store.state.careteam.careteam
    }
  },
  methods: {

  },
  created() {
    console.log('CARETEAMLIST', this.user)
    this.$store.dispatch('careteam/getPendingCareTeamsList', {
      journal_id: this.user.journal_id
    })
  }
}
</script>

<style scoped>
.careteam-info {
  padding: 5px 10px;
}
</style>
